import React from 'react';
import DataServiceTabNav from '../Components/DataService/DataServiceTabNav';
import AccessComponent from '../Components/DataService/AccessComponent';

function DataServiceAccessPage() {
  return (
    <div className="bg-slate-950 text-slate-100">
      <DataServiceTabNav />
      <AccessComponent />
    </div>
  );
}

export default DataServiceAccessPage;


